const DietaryIcons = {};

DietaryIcons.GlutenFree = (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<path d="M7.75 9H10.75C11.35 9 11.75 9.5 11.75 10V10.5H8.25V13.5H10.25V12H11.75V14C11.75 14.5 11.35 15 10.75 15H7.75C7.15 15 6.75 14.5 6.75 14V10C6.75 9.5 7.15 9 7.75 9Z" />
		<path d="M17 9V10.5H14V11.5H16V13H14V15H12.5V9H17Z" />
		<path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" />
	</svg>
);

DietaryIcons.Vegan = (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<path d="M13 8.99997H16C16.6 8.99997 17 9.49997 17 9.99997V10.5H13.5V13.5H15.5V12H17V14C17 14.5 16.6 15 16 15H13C12.4 15 12 14.5 12 14V9.99997C12 9.49997 12.4 8.99997 13 8.99997Z" />
		<path d="M9 13.5L8 8.99997H6.5L8 15H9H10L11.5 8.99997H10L9 13.5Z" />
		<path d="M12 1.99983C6.48 1.99983 2 6.47983 2 11.9998C2 17.5198 6.48 21.9998 12 21.9998C17.52 21.9998 22 17.5198 22 11.9998C22 6.47983 17.52 1.99983 12 1.99983ZM12 19.9998C7.59 19.9998 4 16.4098 4 11.9998C4 7.58983 7.59 3.99983 12 3.99983C16.41 3.99983 20 7.58983 20 11.9998C20 16.4098 16.41 19.9998 12 19.9998Z" />
	</svg>
);

DietaryIcons.Vegetarian = (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" />
		<path d="M12 13.5L11 9H9.5L11 15H12H13L14.5 9H13L12 13.5Z" />
	</svg>
);

export default DietaryIcons;
